import React from 'react'
import { Text, View } from 'react-native'
import { useThemeValue } from '../../ThemeContext'
import { baseFont } from '../../utils/ui'

export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  const { theme } = useThemeValue()

  return (
    <View>
      <Text
        style={{
          ...baseFont('700'),
          color: theme.colors.inactive,
          fontSize: 10,
          marginBottom: 8,
          textTransform: 'uppercase',
          letterSpacing: 1,
        }}
      >
        {label}
      </Text>
      {children}
    </View>
  )
}
